import c from './ELNObjectsViewer.module.css'
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { useMemo } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';



export const ELNObjectsViewer = ({ data, setData, onAddBtnClick, onEditRow, onDeleteRowButtonClick }) => {

  //simple column definitions pointing to flat data
  const columns = useMemo(
    () => [
      {
        header: 'id',
        accessorKey: 'id',
      },
      {
        header: 'Label',
        accessorKey: 'label',
      },
      {
        header: 'Name',
        accessorKey: 'name',
      },
      {
        header: 'Description',
        accessorKey: 'description',
      },
      {
        header: 'Type',
        accessorKey: 'type',
      },
    ],
    [],
  );


  const table = useMaterialReactTable({
    columns,
    data, //must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
    enableRowSelection: true, //enable some features
    enableColumnOrdering: true, //enable a feature for all columns
    enableGlobalFilter: false, //turn off a feature
    enableRowActions: true,

    initialState: {
      density: 'compact', //set default density to compact
      columnVisibility: {
        id: false, //hide the id column by default
      }
    },
    renderRowActions: ({ row }) => (
      <div>
        <Tooltip title="Edit">
          <IconButton onClick={() => onEditRow(row.original)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton onClick={() => onDeleteRowButtonClick(row.original)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </div>
    ),
  });

  return (
    <div className={c.ctr}>
      <div className={c.tblHeader}>
        <h2>ELN Objects Viewer</h2>
        <button onClick={onAddBtnClick} className={c.addBtn} >+ Add Object</button>
      </div>
      <MaterialReactTable table={table} />
    </div>
  )
}